<div class="tw-overflow-y-auto">
  <ul class="tw-list-none tw-p-0 tw-m-0">
    <li class="tw-border-b tw-border-white/10" *ngFor="let region of regions">
      <div class="tw-flex tw-items-center tw-py-1 tw-px-2 tw-cursor-pointer hover:tw-bg-white/5" (click)="toggleRegion(region); highlightRegion(region)">
        <i class="pi tw-text-xs tw-w-5 tw-text-center" [ngClass]="region.visible ? 'pi-angle-down' : 'pi-angle-right'"></i>
        <span class="tw-flex-1 tw-text-[13px] tw-ml-1">{{ region.name }}</span>
        <input
          type="checkbox"
          class="tw-ml-2 tw-w-4 tw-h-4 tw-cursor-pointer"
          [checked]="region.selected"
          [appIndeterminate]="isRegionIndeterminate(region)"
          (change)="onRegionCheckChange(region)"
          (click)="$event.stopPropagation()">
      </div>

      <ul class="tw-list-none tw-p-0 tw-m-0 tw-pl-6" *ngIf="region.visible">
        <li class="tw-border-b tw-border-white/10" *ngFor="let section of region.sections">
          <div class="tw-flex tw-items-center tw-py-1 tw-px-2 tw-cursor-pointer hover:tw-bg-white/5" (click)="toggleSection(section); highlightSection(section)">
            <i class="pi tw-text-xs tw-w-5 tw-text-center" [ngClass]="section.visible ? 'pi-angle-down' : 'pi-angle-right'"></i>
            <span class="tw-flex-1 tw-text-[13px] tw-ml-1">{{ section.name }}</span>
            <input
              type="checkbox"
              class="tw-ml-2 tw-w-4 tw-h-4 tw-cursor-pointer"
              [checked]="section.selected"
              [appIndeterminate]="isSectionIndeterminate(section)"
              (change)="onSectionCheckChange(region, section)"
              (click)="$event.stopPropagation()">
          </div>

          <ul class="tw-list-none tw-p-0 tw-m-0 tw-pl-12" *ngIf="section.visible">
            <li class="tw-border-b tw-border-white/10" *ngFor="let element of section.elements">
              <div class="tw-flex tw-items-center tw-py-1 tw-px-2 tw-cursor-pointer hover:tw-bg-white/5" (click)="highlightElement(element)">
                <span class="tw-flex-1 tw-text-[13px]">{{ element.name }}</span>
                <input
                  type="checkbox"
                  class="tw-ml-2 tw-w-4 tw-h-4 tw-cursor-pointer"
                  [checked]="element.selected"
                  (change)="onElementCheckChange(region, section, element)">
              </div>
            </li>
            <li *ngIf="section.elements.length === 0" class="tw-py-2 tw-px-4 tw-text-white/50 tw-text-xs tw-italic">
              No elements found
            </li>
            <li *ngIf="section.visible" class="tw-border-b tw-border-white/10">
              <div class="tw-flex tw-items-center tw-py-1 tw-px-2 tw-cursor-pointer hover:tw-bg-white/5" (click)="graphics.outlineElement([])">
                <span class="tw-flex-1 tw-text-[13px] tw-text-white/70 tw-italic">Other (Stiffeners, Brackets, Face Plates)</span>
                <input
                  type="checkbox"
                  class="tw-ml-2 tw-w-4 tw-h-4 tw-cursor-pointer"
                  [checked]="section.includeOther"
                  (change)="onOtherCheckChange(region, section)">
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</div>
